var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardPaymentMethod(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Account/Payment Methods") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 25 0 25 20.0187 0 20.0187"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Account/Payment-Methods",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.1396,15.6779 C9.6926,15.6779 10.1396,15.2309 10.1396,14.6779 C10.1396,14.1249 9.6926,13.6779 9.1396,13.6779 L4.9416,13.6779 C4.3886,13.6779 3.9416,14.1249 3.9416,14.6779 C3.9416,15.2309 4.3886,15.6779 4.9416,15.6779 L9.1396,15.6779 Z",
    id: "Fill-1",
    fill: "#282827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.666,15.6779 C15.219,15.6779 15.666,15.2309 15.666,14.6779 C15.666,14.1249 15.219,13.6779 14.666,13.6779 L12.946,13.6779 C12.394,13.6779 11.946,14.1249 11.946,14.6779 C11.946,15.2309 12.394,15.6779 12.946,15.6779 L14.666,15.6779 Z",
    id: "Fill-3",
    fill: "#282827"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,5.425 L2,3.554 C2,2.697 2.697,2 3.554,2 L21.446,2 C22.303,2 23,2.697 23,3.554 L23,5.425 L2,5.425 Z M21.446,0 L3.554,0 C1.594,0 0,1.594 0,3.554 L0,9.478 C0,10.03 0.447,10.478 1,10.478 C1.553,10.478 2,10.03 2,9.478 L2,7.425 L23,7.425 L23,16.464 C23,17.321 22.303,18.019 21.446,18.019 L3.554,18.019 C2.697,18.019 2,17.321 2,16.464 L2,14.589 C2,14.036 1.553,13.589 1,13.589 C0.447,13.589 0,14.036 0,14.589 L0,16.464 C0,18.424 1.594,20.019 3.554,20.019 L21.446,20.019 C23.406,20.019 25,18.424 25,16.464 L25,3.554 C25,1.594 23.406,0 21.446,0 L21.446,0 Z",
    id: "Fill-5",
    fill: "#282827"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardPaymentMethod);
export default __webpack_public_path__ + "static/media/dashboard_payment_method.827fe8c959479e2024bc995c9434de1e.svg";
export { ForwardRef as ReactComponent };